import React  from "react";
import { connect } from "react-redux";
import SummaryHeader from "components/header/SummaryHeader";
import JobPostDashBoard from "./components/JobPostDashBoard";
import { 
	LuUsers
} from "react-icons/lu";

const JobPosts = () => {
	
	return (
	    <div className="grid h-full grid-cols-1 gap-4">
			<SummaryHeader
				title={"Job Posts"}
				icon={LuUsers}
				description={"Publish and manage job openings to attract and track top talent."}
				color={"green"}
			/>
			<>
				<JobPostDashBoard />
			</>
		</div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(JobPosts);